import script from "./Packages.vue?vue&type=script&setup=true&lang=js"
export * from "./Packages.vue?vue&type=script&setup=true&lang=js"

import "./Packages.vue?vue&type=style&index=0&id=37d9adaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d9adaf"]])

export default __exports__